export default "__VITE_ASSET__CigMTrLr__"